module.exports = __webpack_public_path__ + "static/synesthesia-demo-7274d4b5ec805e0720a9d1fac2130ee2.mp4";